import { isNullOrUndefined } from "et3-type-guards";
import { memoize } from "lodash";
import { runInAction } from "mobx";
import getApproveRejectStore from ".";

import { Ti18nKeys } from "../../constants/i18n";
import { TDescriptionType, TCorePage } from "../../Types";
import getCorePopUpStore from "../core/core-popup-store";
import getUserAdvancedStore from "../user-store/advanced-store";
import { changeAlbumStatusInLocal } from "./change-album-status-local";
import { handleApproveRejectCardCount } from "./handle-approve-reject-card-count";

class SuccessApproveRejectStatus {
  approveUserPictureClient = (
    from: TCorePage,
    userId: number,
    imageID: string,
    resolvePendingPicture: boolean
  ) => {
    if (from === "APPROVAL_DATA") {
      getApproveRejectStore()
        .approvalData.get()
        .forEach((value, index) => {
          if (value.user_id === userId) {
            runInAction(() => {
              changeAlbumStatusInLocal(index, imageID, "Y");
            });
            handleApproveRejectCardCount({
              index,
              actionType: "image",
              resolvingPendindData: resolvePendingPicture
            });
          }
        });
    }
    if (from === "USER_ADVANCED") {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      if (!isNullOrUndefined(oldUserData)) {
        const newUserData = Object.assign(oldUserData, {
          pictureStatus: "APPROVED"
        });
        getUserAdvancedStore().userData.set(userId, newUserData);
      }
      getCorePopUpStore().showSuccessMessage("PICTURE_APPROVED_SUCCESSFULLY");
    }
  };

  rejectUserPictureClient = (
    from: TCorePage,
    userId: number,
    imageID: string,
    resolvePendingPicture: boolean
  ) => {
    if (from === "APPROVAL_DATA") {
      getApproveRejectStore()
        .approvalData.get()
        .forEach((value, index) => {
          if (value.user_id === userId) {
            runInAction(() => {
              changeAlbumStatusInLocal(index, imageID, "N");
            });
            handleApproveRejectCardCount({
              index,
              actionType: "image",
              resolvingPendindData: resolvePendingPicture
            });
          }
        });
    }
    if (from === "USER_ADVANCED") {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      if (!isNullOrUndefined(oldUserData)) {
        const newUserData = Object.assign(oldUserData, {
          pictureStatus: "REJECTED"
        });
        getUserAdvancedStore().userData.set(userId, newUserData);
      }
      getCorePopUpStore().showSuccessMessage("PICTURE_REJECTED_SUCCESSFULLY");
    }
  };

  approveDescriptionClient = (
    descriptionType: TDescriptionType,
    from: TCorePage,
    userId: number,
    isSelfDescription: boolean,
    resolvePendingDescription: boolean
  ) => {
    if (from === "APPROVAL_DATA") {
      getApproveRejectStore()
        .approvalData.get()
        .forEach((value, index) => {
          if (value.user_id === userId) {
            descriptionType === "self_description"
              ? (getApproveRejectStore().approvalData.get()[
                  index
                ].descriptionStatus = "approved")
              : (getApproveRejectStore().approvalData.get()[
                  index
                ].peerDescriptionStatus = "approved");
            handleApproveRejectCardCount({
              index,
              actionType: "description",
              resolvingPendindData: resolvePendingDescription
            });
          }
        });
    }
    if (from === "USER_ADVANCED") {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      if (!isNullOrUndefined(oldUserData)) {
        const approvedDescription = isSelfDescription
          ? {
              descriptionStatus: "APPROVED"
            }
          : {
              peerDescriptionStatus: "APPROVED"
            };
        const newUserData = Object.assign(oldUserData, approvedDescription);
        getUserAdvancedStore().userData.set(userId, newUserData);
      }
      const messageKey: Ti18nKeys = isSelfDescription
        ? "DESCRIPTION_APPROVED_SUCCESSFULLY"
        : "PEER_DESCRIPTION_APPROVED_SUCCESSFULLY";
      getCorePopUpStore().showSuccessMessage(messageKey);
    }
  };

  rejectDescriptionClient = (
    descriptionType: TDescriptionType,
    from: TCorePage,
    userId: number,
    isSelfDescription: boolean,
    resolvePendingDescription: boolean
  ) => {
    if (from === "APPROVAL_DATA") {
      getApproveRejectStore()
        .approvalData.get()
        .forEach((value, index) => {
          if (value.user_id === userId) {
            descriptionType === "self_description"
              ? (getApproveRejectStore().approvalData.get()[
                  index
                ].descriptionStatus = "not_filled")
              : (getApproveRejectStore().approvalData.get()[
                  index
                ].peerDescriptionStatus = "not_filled");

            handleApproveRejectCardCount({
              index,
              actionType: "description",
              resolvingPendindData: resolvePendingDescription
            });
          }
        });
    }
    if (from === "USER_ADVANCED") {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      const rejectedDescription = isSelfDescription
        ? {
            descriptionStatus: "REJECTED"
          }
        : {
            peerDescriptionStatus: "REJECTED"
          };
      if (!isNullOrUndefined(oldUserData)) {
        const newUserData = Object.assign(oldUserData, rejectedDescription);
        getUserAdvancedStore().userData.set(userId, newUserData);
      }
      const messageKey: Ti18nKeys = isSelfDescription
        ? "DESCRIPTION_REJECTED_SUCCESSFULLY"
        : "PEER_DESCRIPTION_REJECTED_SUCCESSFULLY";
      getCorePopUpStore().showSuccessMessage(messageKey);
    }
  };
}

const getSuccessApproveRejectStatus = memoize(
  () => new SuccessApproveRejectStatus(),
  () => 1
);
export default getSuccessApproveRejectStatus;
